import { createFileRoute } from '@tanstack/react-router'
import AllBlogsPage from '#/pages/AllBlogsPage'
import { blogsQueryOptions } from '#/features/blogs/hooks/useBlogs'
import { tagsQueryOptions } from '#/features/courses/hooks/useTags'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'

export type BlogsSearch = {
  page?: number
  tags?: string
  search?: string
}

export const Route = createFileRoute('/_home/blog/')({
  validateSearch: (search: Record<string, unknown>): BlogsSearch => ({
    page: Number(search?.page) || 1,
    tags: (search?.tags as string) || undefined,
    search: (search?.search as string) || undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps }) => {
    await Promise.all([
      queryClient.ensureQueryData(
        blogsQueryOptions({
          page: deps.page,
          tags: deps.tags,
          search: deps.search,
          limit: 9,
        }),
      ),
      queryClient.ensureQueryData(tagsQueryOptions()),
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 5 })),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "Blog & Articles | Wa'allamah",
      },
      {
        name: 'description',
        content:
          "Read inspiring Islamic reflections, Tajweed tips, and Quran learning guides from Wa'allamah educators.",
      },
    ],
  }),
  component: AllBlogsPage,
})
